import {styled} from '@esgi/ui/theme';
import {Drawer} from '@esgi/main/kits/common';

export const DrawerBody = styled(Drawer.Body, {
	display: 'grid !important',
	gridTemplateRows: 'auto 1fr',
	gap: '$3',
	overflow: 'hidden',
});
